import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import Tooltip from '../../library/tooltip/tooltip';
import Typography from '../../library/typography/typography';

import { PRODUCT_GBB_CONTENT_QUERY } from './graphql/product-gbb-queries.js';

import './product-gbb.scss';

interface ProductGBBProps {
  className?: string;
  showGBBTooltip?: boolean;
  value?: string;
}

function ProductGBB(props: ProductGBBProps) {
  const { className, value, showGBBTooltip = false } = props;
  const { data, loading } = useQuery(PRODUCT_GBB_CONTENT_QUERY, {
    skip: !showGBBTooltip || !value
  });

  if (!value || loading) {
    return null;
  }

  const gbbLowerCase = value?.toLowerCase();

  const gbbTooltipContent = data?.recommendationQueries?.toolTips?.find(
    v => v.key === gbbLowerCase
  );

  return showGBBTooltip ? (
    <Tooltip
      content={gbbTooltipContent?.value}
      hoverOver
      render={() => (
        <Typography
          className={className}
          size="extraSmall"
          styleName={gbbLowerCase}
          tag="span"
        >
          {value}
        </Typography>
      )}
    />
  ) : (
    <Typography
      className={className}
      size="extraSmall"
      styleName={gbbLowerCase}
      tag="span"
    >
      {value}
    </Typography>
  );
}

export default ProductGBB;
